export default {
  chartAreaBorder: {
    id: 'chartAreaBorder',
    beforeDraw (chart, args, options) {
      const expectedDatasets = chart.data.labels.length
      if (expectedDatasets < 1) {
        return
      }

      const { ctx, chartArea: { left, top, bottom, right } } = chart
      ctx.save()
      ctx.strokeStyle = options.borderColor
      ctx.lineWidth = options.borderWidth

      ctx.setLineDash(options.borderDash || [])
      ctx.lineDashOffset = options.borderDashOffset
      const width = right - left
      const height = bottom - top
      ctx.strokeRect(left, top, width, height)

      const scaleX = chart.scales['x-axis-0']
      const scaleY = chart.scales['y-axis-0']
      const stepX = (scaleX.right - scaleX.left) / expectedDatasets

      ctx.beginPath()
      for (let i = 1; i !== expectedDatasets; ++i) {
        const iLeft = scaleX.left + i * stepX
        ctx.moveTo(iLeft, scaleY.bottom)
        ctx.lineTo(iLeft, scaleY.top)
      }

      ctx.stroke()
      ctx.restore()
    },

    afterDatasetDraw (chart) {
      const { ctx, chartArea: { left, right } } = chart
      const scaleY = chart.scales['y-axis-0']
      const c = '#71ce3c'
      ctx.fillStyle = `${c}60`
      ctx.strokeStyle = `${c}f9`
      ctx.lineWidth = 3

      const width = right - left
      const limity = scaleY.getPixelForValue(80)
      ctx.setLineDash([10, 5])
      ctx.beginPath()
      ctx.moveTo(left + 1, limity)
      ctx.lineTo(left + width - 1, limity)
      ctx.fillRect(left, scaleY.top, right - 2, limity - scaleY.top)
      ctx.stroke()
    }
  },

  plotDecimalScale: function () {
    return {
      label: 'Nombre maximal de décimales',
      key: `plot-decimal-scale`,
      options: { numeral: true },
      default: 3,

      toConfig: function (value) {
        const v = value == null ? 3 : parseInt(value)
        return {
          decimalScale: isNaN(v) ? 3 : v
        }
      }
    }
  },

  axesFontSize: {
    label: 'Taille de la police sur les axes (px)',
    options: { numeral: true },
    key: 'font-size',
    default: 12,

    toConfig: function (value) {
      const v = value == null ? 12 : parseInt(value)
      return {
        scales: {
          yAxes: [{
            ticks: {
              fontSize: v
            }
          }],
          xAxes: [{
            ticks: {
              fontSize: v
            }
          }]
        }
      }
    }
  },

  datalabelFontSize: function (defaultValue = 12) {
    return {
      label: 'Taille de la police sur le graphique (px)',
      options: { numeral: true },
      key: 'datalabel-font-size',
      default: defaultValue,

      toConfig: function (value) {
        const v = value == null ? defaultValue : parseInt(value)
        return {
          plugins: {
            datalabels: {
              font: {
                size: v
              }
            }
          }
        }
      }
    }
  },

  incidenceTitles: function (titles) {
    return [
      {
        label: 'Modifier le titre',
        key: 'plot-incidence-title',
        type: 'text',
        default: titles.main,
        toConfig: function (value) {
          if (value === '') {
            return {}
          }
          return {
            title: {
              titles: {
                main: value
              }
            }
          }
        }
      },
      {
        label: 'Modifier le sous-titre',
        key: 'plot-incidence-subtitle',
        type: 'text',
        default: titles.sub,
        toConfig: function (value) {
          if (value === '') {
            return {}
          }
          return {
            title: {
              titles: {
                sub: value
              }
            }
          }
        }
      }
    ]
  },

  title: {
    label: 'Modifier le titre',
    key: 'chart-title',
    type: 'text',
    default: '',

    toConfig: function (value) {
      if (value === '') {
        return {}
      }

      return {
        title: {
          text: value
        }
      }
    }
  },

  legendOnRight: {
    label: 'Placer la légende à droite',
    key: 'legend-on-right',
    type: 'checkbox',
    default: false,

    toConfig: function (value) {
      return {
        legend: {
          position: value ? 'right' : 'bottom'
        }
      }
    }
  },

  hideLegend: {
    label: 'Masquer la légende',
    key: 'hide-legend',
    type: 'checkbox',
    default: false,

    toConfig: function (value) {
      return {
        legend: {
          display: !value
        }
      }
    }
  },

  titleFontSize: function (defaultValue) {
    const def = defaultValue == null ? 12 : defaultValue
    return {
      label: 'Taille de la police du titre',
      options: { numeral: true },
      key: 'title-font-size',
      default: def,

      toConfig: function (value) {
        const v = value == null ? def : parseInt(value)
        return {
          title: {
            fontSize: v
          }
        }
      }
    }
  },

  subtitleFontSize: function (defaultValue) {
    const def = defaultValue == null ? 10 : defaultValue
    return {
      label: 'Taille de la police du sous-titre',
      options: { numeral: true },
      key: 'subtitle-font-size',
      default: def,

      toConfig: function (value) {
        const v = value == null ? def : parseInt(value)
        return {
          title: {
            subtitleFontSize: v
          }
        }
      }
    }
  },

  hideDatalabelBelowValue: {
    label: 'Masquer les valeurs inférieures à la valeur suivante :',
    key: 'hide-datalabel-below-value',
    options: { numeral: true },
    default: 0,

    toConfig: function (value) {
      return {
        plugins: {
          datalabels: {
            minValue: value
          }
        }
      }
    }
  },

  hideDatalabelBelowPercent: {
    label: 'Masquer les valeurs inférieures au %age suivant',
    key: 'hide-datalabel-below-percent',
    options: { numeral: true },
    default: 0,

    toConfig: function (value) {
      return {
        plugins: {
          datalabels: {
            minPercent: value
          }
        }
      }
    }
  },

  legendBoxWidth: {
    label: 'Taille des boîtes sur la légende (px)',
    key: 'legend-box-width',
    options: { numeral: true },
    default: 40,

    toConfig: function (value) {
      const v = value == null ? 40 : parseInt(value)
      return {
        legend: {
          labels: {
            boxWidth: v
          }
        }
      }
    }
  },

  legendFontSize: {
    label: 'Taille de la police de la légende (px)',
    key: 'legend-font-size',
    options: { numeral: true },
    default: 12,

    toConfig: function (value) {
      const v = value == null ? 12 : parseInt(value)
      return {
        legend: {
          labels: {
            fontSize: v
          }
        }
      }
    }
  },

  maxYValue: function (t) {
    return {
      label: `${t} sur l'axe y`,
      options: { numeral: true },
      key: 'max-value-y',
      default: '',

      toConfig: function (value) {
        if (value == null || value === '') {
          return {}
        }
        return {
          scales: {
            yAxes: [{
              ticks: {
                max: parseFloat(value)
              }
            }]
          }
        }
      }
    }
  },

  minYValue: function (t) {
    return {
      label: `${t} sur l'axe y`,
      options: { numeral: true },
      key: 'min-value-y',
      default: '',

      toConfig: function (value) {
        if (value == null || value === '') {
          return {}
        }

        return {
          scales: {
            yAxes: [{
              ticks: {
                min: parseFloat(value)
              }
            }]
          }
        }
      }
    }
  },

  boxplotPercentWidth: function (d) {
    return {
      label: `Largeur d'une boîte à moustache (%)`,
      key: 'boxplot-percent-width',
      options: { numeral: true },

      default: d,

      toConfig: function (value) {
        const v = value == null ? d : parseInt(value)
        return {
          scales: {
            xAxes: [
              {
                barPercentage: v / 100.0
              }
            ]
          }
        }
      }
    }
  },

  toggleDataset: function (key, label, dataset) {
    return {
      label: label,
      key: `toggle-${key}`,
      type: 'checkbox',
      default: !dataset.hidden,

      onChange: function (value) {
        dataset.hidden = !value
      }
    }
  },

  toggleQ1Q3: function () {
    return {
      label: 'Retirer Q1 et Q3 de la légende',
      key: `toggleQ1Q3`,
      type: 'checkbox',
      default: false,

      toConfig: function (value) {
        return {
          showQ1Q3: !value
        }
      }
    }
  },

  toggleStandardDeviation: function () {
    return {
      label: `Retirer l'écart type de la légende`,
      key: `toggleStandardDeviation`,
      type: 'checkbox',
      default: false,

      toConfig: function (value) {
        return {
          showSd: !value
        }
      }
    }
  },

  toggleQuality: function (dset) {
    return {
      label: `Forcer la couleur par défaut pour les pastilles`,
      key: `toggleQuality`,
      type: 'checkbox',
      default: false,

      onChange: function (value) {
        dset.showQuality = !value
      }
    }
  },

  toggleIndicatorColors: function () {
    return {
      label: `Forcer la couleur du %age d'établissements dans la cible`,
      key: `toggleIndicatorColors`,
      type: 'checkbox',
      default: false,

      toConfig: function (value) {
        return {
          showIndicatorColors: !value
        }
      }
    }
  },

  borderWidth: {
    label: 'Taille de la bordure des sections (px)',
    key: 'border-width',
    options: { numeral: true },
    default: 1,

    toConfig: function (value) {
      const v = value == null ? this.default : parseInt(value)
      return {
        elements: {
          arc: {
            borderWidth: v
          }
        }
      }
    }
  },

  selectFormatter: function (list, initial = 0) {
    return {
      label: `Affichage des valeurs sur le graphique`,
      type: 'list',
      values: list,
      default: initial,

      toConfig: function (value) {
        let v = value == null ? this.default : parseInt(value)
        if (v < 0 || v >= this.values.length) {
          v = 0
        }

        return {
          formatter: this.values[v].formatter
        }
      }
    }
  }
}
